<template>
  <div>
    <div class="innerBox filter">
      <div class="d-flex flex-row">
        <div>
          <h2 class="page-title">User Management - Leadtime Settings</h2>
        </div>
      </div>
    </div>
    <div class="innerBox mt-3">
      <div class="col" style="padding-left: 0">
        <div>
          <h2 style="font-weight: bold; color: #4d4d4d; font-size: 24px">
            Update Leadtime
          </h2>
        </div>
        <div class="d-flex flex-row justify-content-between mt-3">
          <div class="d-flex flex-row">
            <div class="mr-5 mt-1">
              <span style="font-size: 16px; color: #000000">Tanggal</span>
            </div>
            <div class="mr-5">
              <div class="input-group">
                <flat-pickr
                  :config="rangePickr"
                  placeholder="Select Date"
                  v-model="selected.tanggal"
                ></flat-pickr>
                <span
                  class="input-group-text bg-white"
                  style="
                    border-top-left-radius: 0;
                    border-bottom-left-radius: 0;
                    border: 0;
                    box-shadow: 0 0 6px #0000000f;
                    background-color: #ededed !important;
                  "
                >
                  <i class="fas fa-calendar" style="color: black"></i>
                </span>
              </div>
            </div>
            <div class="mr-5 mt-1">
              <span style="font-size: 16px; color: #000000"
                >Leadtime range</span
              >
            </div>
            <div class="mr-5">
              <MultiSelect
                v-model="selected.value"
                :options="value"
                :allow-empty="false"
                placeholder="Select Range"
                class="tms-multiselect"
                style="width: 250px"
              />
            </div>
          </div>
          <div class="d-flex flex-row justify-content-end">
            <button
              class="btn"
              type="button"
              style="
                background-color: #f36f21;
                color: white;
                width: 100%;
                font-weight: bold;
                margin: 0;
              "
              @click="onClick"
            >
              Update
            </button>
          </div>
        </div>
      </div>
    </div>
    <div class="innerBox mt-3">
      <div class="col" style="padding-left: 0">
        <div>
          <h2 style="font-weight: bold; color: #4d4d4d; font-size: 24px">
            Leadtime Updated History
          </h2>
        </div>
        <div class="mt-3">
          <vue-universal-table
            api_url="/api/settings/list"
            :disable_limit_per_page="true"
            :table_striped="false"
            :indexing="true"
            :fields="vue_universal_table.fields"
            :buttons="vue_universal_table.buttons"
            :update="vue_universal_table.update"
            @onEdit="editLeadtimeSettings"
            @onDelete="deleteLeadtimeSettings"
          />
        </div>
      </div>
    </div>
    <leadtime-settings-modal 
      v-if="showModal" 
      :data="editData"
      @closeModal="showModal = false"
      @refreshData="vue_universal_table.update++"
    />
  </div>
</template>
<script>
import moment from 'moment';
import LeadtimeSettingsModal from './LeadtimeSettingsModal';
export default {
  metaInfo: {
    title: "Leadtime Settings",
  },
  data() {
    return {
      rangePickr: {
        dateFormat: "Y-m-d",
        altInput: true,
        altFormat: "d-m-Y",
        altInputClass: "form-control input elegant-flatpickr",
        minDate: moment().format('YYYY-MM-DD'),
      },
      showModal: false,
      editData: null,
      vue_universal_table: {
        fields: [
          {
            title: "Tanggal Update",
            variable: "tanggal",
            disable_sort: true,
          },
          {
            title: "Leadtime Range",
            variable: "value",
            disable_sort: true
          },
          {
            title: "Status",
            variable: "status",
            disable_sort: true
          }
        ],
         buttons: [
          {
            title: "Edit",
            variable: null,
            class: "fas fa-edit btn-secondary rounded-button float-right",
            condition: `data.status === 'ACTIVE' && data.editable === true`
          },
          {
            title: "Delete",
            variable: "id",
            class: "fas fa-trash btn-secondary rounded-button",
            condition: `data.status === 'ACTIVE' && data.editable === true`
          },
        ],
        update: 0
      },
      value: [4, 5, 6, 7],
      selected: {
        tanggal: "",
        value: "",
      },
    };
  },
  components: {
    LeadtimeSettingsModal
  },
  methods: {
    onClick() {
      this.$http
        .post("/api/settings/save", this.selected)
        .then(() => {
          this.$swal.fire({
            title: "Success!",
            icon: "success",
            text: "Successfully Insert Leadtime settings",
          });
          this.vue_universal_table.update++;
        })
        .catch((err) => {
          this.$swal.fire({
            title: "Error!",
            icon: "error",
            text: err.response.data.message,
          });
        });
    },
    editLeadtimeSettings(leadtimeSettings) {
      this.editData = JSON.parse(leadtimeSettings);
      this.showModal = true;
    },
    deleteLeadtimeSettings(id) {
      this.$swal
        .fire({
          title: "Are you sure?",
          text: "You won't be able to revert this!",
          icon: "warning",
          showCancelButton: true,
          confirmButtonColor: "#3085D6",
          cancelButtonColor: "#D33",
          confirmButtonText: "Yes, delete it!",
          cancelButtonText: "No, cancel",
        })
        .then((result) => {
          if (result.value) {
            this.$http
              .delete("/api/settings/delete/" + id)
              .then(() => {
                this.$swal.fire({
                  title: "Success!",
                  icon: "success",
                  type: "success",
                  text: `Leadtime settings has been successfully deleted`,
                });
                // Fetch and update data after successful deletion
                this.vue_universal_table.update++;
              })
              .catch((err) => {
                this.$swal.fire({
                  title: "Error!",
                  icon: "error",
                  type: "error",
                  text: err.response.data.message,
                });
              });
          }
        });
    }
  },
};
</script>
<style scoped>
.box-content {
  padding: 20px;
  border-radius: 10px;
}

.align-middle {
  display: flex;
  align-items: center;
}

.page-title {
  font-size: 27px;
  font-weight: bold;
  margin: 0;
}

.innerBox {
  background-color: white;
  border-radius: 8px;
  box-shadow: 0px 3px 10px #0000000f;
  padding: 20px;
}
</style>
